// export const URL = "http://raise.test/";
export const URL = process.env.REACT_APP_ENDPOINT_URL;
export const URL_LOCAL = process.env.REACT_APP_ENDPOINT_URL2;
// export const URL = process.env.REACT_APP_URL;
export const CLIENT_SECRET = 'QRLf3uEcqi1Rh6iUAdTAoUY3kJTBZNqi2jjfItwA';
export const CLIENT_ID = '3';
export const endpoints = {
  getToken: () => ['POST', `${URL}oauth/token`],
  getProfile: () => ['GET', `${URL}api/auth-user`],
  getPayment: (intent) => ['GET', `${URL_LOCAL}payment/${intent}`],
  newPayment: () => ['POST', `${URL_LOCAL}payment`],
  getCompaniesAssets: () => ['GET', `${URL}api/companies-assets`],
  getAssetSummary: (id) => ['GET', `${URL}api/asset-summary/${id}`],
  getRemoteConfig: () => ['GET', `${URL}api/remote-config`],
  getPointCloudsForAsset: (assetId) => ['GET', `${URL}api/assets/${assetId}/point-clouds`],
  get360Model: (assetId) => ['GET', `${URL}api/assets/${assetId}/360-models`],
  getRealityMeshesForAsset: (assetId) => ['GET', `${URL}api/assets/${assetId}/reality-meshes`],
  createInspection: (assetId) => ['POST', `${URL}api/assets/${assetId}/aerial-inspections`],
  uploadInspectionMedia: (inspectionId) => ['POST', `${URL}api/aerial-inspections/${inspectionId}/inspection-medias`],
  getInspection: (inspectionId) => ['GET', `${URL}api/aerial-inspections/${inspectionId}`],
  getReportsForAsset: (assetId, categoryId = null) => [
    'GET',
    `${URL}api/assets/${assetId}/site-reports${!!categoryId || ''}`,
  ],
  updateInspectionMedia: (mediaId) => ['POST', `${URL}api/inspection-medias/${mediaId}`],
  deleteInspectionMedia: (mediaId) => ['DELETE', `${URL}api/inspection-medias/${mediaId}`],
  getAnnotation: (mediaId) => ['GET', `${URL}api/annotations/inspectionmedia/${mediaId}`],
  postAnnotation: (mediaId) => ['POST', `${URL}api/annotations/inspectionmedia/${mediaId}`],
  addRealityMeshForAsset: (assetId) => ['POST', `${URL}api/asset/${assetId}/reality-mesh-captures/store`],
  getMapLayersForAsset: (assetId) => ['GET', `${URL}api/assets/${assetId}/orthophotos`],
  getMapKmlForAsset: (assetId) => ['GET', `${URL}api/assets/${assetId}/mapkml`],
  createMapKmlForAsset: (assetId) => ['POST', `${URL}api/assets/${assetId}/mapkml`],
  updateMapKml: (kmlId) => ['POST', `${URL}api/mapkml/${kmlId}`],
  getAnnotations: assetId => ['GET', `${URL}api/annotations/asset/${assetId}`],
  getStatistics: () => ['GET', `${URL}api/annotations_statistic`],

  getCompanyOrthophotos: (companyId) => ['GET', `${URL}api/company/${companyId}/orthophotos`],
};
